type Match = { text: string; index: number };

const MATCH_URL_REGEX =
  /https?:\/\/[A-Za-z0-9-_~]+(\.[A-Za-z0-9-_~:/]+)+((\?|#)[^—.?\s]+)?/g;

function matchUrls(html: string): Match[] {
  const matches = Array.from(html.matchAll(MATCH_URL_REGEX));
  return matches.map((match) => ({ text: match[0], index: match.index }));
}

function replaceMatch(html: string, match: Match, replacement: string) {
  const { text, index } = match;

  const before = html.substring(0, index);
  const after = html.substring(index + text.length);
  return before + replacement + after;
}

function getUnlinkedMatches(html: string): Match[] {
  return matchUrls(html).filter(({ index }) => {
    const closingIndex = html.indexOf('</a>', index);
    if (closingIndex === -1) return true;

    const previousClosingIndex = html.lastIndexOf('</a>', closingIndex - 1);
    const openingIndex = html.indexOf('<a', previousClosingIndex);
    return openingIndex > index;
  });
}

/**
 * Function that wraps text links in an HTML string with anchor tags.
 * This function is idempotent - it does not generate duplicate nested <a> tags
 */
export function hyperlinkHtml(html: string): string {
  return getUnlinkedMatches(html)
    .toReversed()
    .reduce((newHtml, match) => {
      const replacement = `<a href="${match.text}" rel="noopener noreferrer" target="_blank">${match.text}</a>`;
      return replaceMatch(newHtml, match, replacement);
    }, html);
}
